import { gql, useQuery } from '@nerdwallet/apollo';
import appConfigs from '@nerdwallet/app-config';
import { useExperiment } from '@nerdwallet/features';
import { useSegmentAnalytics } from '@nerdwallet/seo-analytics';
import { useEffect, useState } from 'react';
import { inputChange } from '~/client/lib/actions';

const HOUSEHOLD_INCOME_PREFILL_QUERY = gql`
  query preFillService($input: PreFillInput!) {
    preFill(input: $input) {
      annualIncome {
        value
      }
    }
  }
`;

interface UsePrefillProps {
  dispatch: any;
  formName: string;
  vertical: string;
}

interface PrefillData {
  annualIncome?: number;
}

const usePrefill = ({
  dispatch,
  formName,
  vertical,
}: UsePrefillProps): PrefillData => {
  const analytics = useSegmentAnalytics();
  const [anonymousId, setAnonymousId] = useState(null);
  const { assignedVariantName } = useExperiment({
    testName: 'EXPERT-1973_pre-fill-diy-tools',
    anonymousId,
    options: { skip: !anonymousId },
  });

  const { data } = useQuery(HOUSEHOLD_INCOME_PREFILL_QUERY, {
    skip: !anonymousId,
    ssr: false,
    variables: {
      input: {
        anonymousId,
        trackingInput: {
          // eslint-disable-next-line no-underscore-dangle
          callerDeployableName: appConfigs?._meta?.deployable,
          // eslint-disable-next-line no-underscore-dangle
          callerDeployableVersion: appConfigs?._meta?.version,
          formName,
          vertical,
        },
      },
    },
  });

  useEffect(() => {
    // @ts-ignore: type for segment instance does not have analytics field
    const analyticsInstance = analytics?.analytics?.analytics;
    if (!analyticsInstance) {
      return;
    }

    analyticsInstance
      .user()
      .then((user: any) => user.anonymousId())
      .then((anonId: string) => setAnonymousId(anonId));

    // @ts-ignore: type for segment instance does not have analytics field
  }, [analytics?.analytics?.analytics]);

  useEffect(() => {
    if (!data?.preFill?.annualIncome?.value) return;
    if (assignedVariantName === 'control') return;

    dispatch(
      inputChange({
        manualInputs: {
          income: data?.preFill?.annualIncome?.value,
        },
      })
    );
  }, [data, dispatch, assignedVariantName]);

  return {
    annualIncome: data?.preFill?.annualIncome?.value,
  };
};

export default usePrefill;
